import React, { useState, useEffect } from "react";
import { useFetch } from "services/hooks/useFetch";
import * as Mui from "@mui/material";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { Apply } from "./Apply";
import { Approve } from "./Approve";
import { History } from "./History";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { themes, defaultAllSelection } from "services/constants";
import { useSelector, useDispatch } from "react-redux";
import DefaultMonthDateRangePicker from "../DateRangePicker";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import moment from "moment";
import { checkFirstLevelApproverPermission } from "services/utils/HelperFunction";

export const AdvanceSalary = () => {
  const [userName, setUserName] = useState("All");
  const [departmentChange, setDepartmentChange] = useState(true);
  const [userChange, setUserChange] = useState(true);
  const [userId, setUserId] = useState(defaultAllSelection);
  const [departmentData, setDepartmentData] = useState([]);
  const [overTimeScreen, setOverTimeScreen] = useState("Approve");
  const [selectComponent, setSelectComponent] = useState("Approve");
  const [startDate, setStartDate] = useState("");
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);
  const [endDate, setEndDate] = useState("");
  const { domain, token, userDetails, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const dispatch = useDispatch();
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const handleChange = (event, newAlignment) => {
    if (newAlignment) {
      setOverTimeScreen(newAlignment);
      dispatch(setGlobalSearchValue(""));
    }
  };
  const { result: membersData, setLoad: reCallMemberApi } = useFetch(
    `${domain}get-department-based-user/?department_id=${departmentId}&user_id=${userDetails.id}`
  );

  const renderComponent = () => {
    switch (selectComponent) {
      case "Approve":
        return (
          <Approve
            departmentId={departmentId}
            departmentChange={departmentChange}
            setDepartmentChange={setDepartmentChange}
            overTimeScreen={overTimeScreen}
            
          />
        );
      case "History":
        return (
          <History
            overTimeScreen={overTimeScreen}
            departmentId={departmentId}
            departmentChange={departmentChange}
            setDepartmentChange={setDepartmentChange}
            userChange={userChange}
            setUserChange={setUserChange}
            userId={userId}
            startDate={startDate}
            endDate={endDate}
          />
        );
      case "Apply":
        return <Apply />;
      default:
        break;
    }
  };
  useEffect(() => {
    dispatch(setDepartmentName("All"));
    dispatch(setDepartmentId(99999));
  }, [dispatch]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${userDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const allDepartment = {
            id: defaultAllSelection,
            department_name: "All",
          };
          setDepartmentData([allDepartment, ...res]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchDepartmentData();
  }, [domain, token, userDetails.id]);

  const updateDepartmentName = (event, data) => {
    if (data) {
      dispatch(setDepartmentName(data.label));
      dispatch(setDepartmentId(data.id));
      localStorage.setItem("approveLeaveDepartmentId", data.id);
      localStorage.setItem("approveLeaveDepartmentName", data.label);
      setUserName("All");
      setUserId(defaultAllSelection);
      setDepartmentChange(true);
    }
  };

  const updateUserName = (event, data) => {
    if (data) {
      setUserName(data);
      setUserId(data.user_id);
      setUserChange(true);
      reCallMemberApi(true);
      setShowAutoCompleteAvathar(false);
    } else {
      setShowAutoCompleteAvathar(true);
    }
  };

  const handleStartDate = async (startDate, endDate) => {
    setStartDate(
      moment(new Date(startDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setEndDate(
      moment(new Date(endDate.split("/").reverse().join("-"))).format(
        "YYYY-MM-DD"
      )
    );
    setUserChange(true);
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 5, paddingLeft: 3 }}>
        <Mui.Grid item xs={5}>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: 500,
              height: 55,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Mui.ToggleButtonGroup
              value={overTimeScreen}
              exclusive
              onChange={handleChange}
              sx={{
                display: "flex",
                width: "100%",
                height: "100%",
                position: "absolute",
                borderRadius: "30px",
                backgroundColor: themes.lightBrown,
              }}
            >
              <Mui.ToggleButton
                value="Approve"
                onClick={() => setSelectComponent("Approve")}
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  borderRadius: "30px",
                  fontWeight: 600,
                  border: "none",
                  color:
                    overTimeScreen === "Approve"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    overTimeScreen === "Approve"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: "30px",
                    "&.Mui-selected": {
                      borderRadius: "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      overTimeScreen === "Approve"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      overTimeScreen === "Approve"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
              >
                Approve
              </Mui.ToggleButton>
              <Mui.ToggleButton
                value="History"
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  fontWeight: 600,
                  borderRadius: !checkFirstLevelApproverPermission(
                    userScreenAccess?.module_details,
                    "Approve",
                    "Advance Salary"
                  )
                    ? "30px"
                    : "0px",
                  border: "none",
                  color:
                    overTimeScreen === "History"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    overTimeScreen === "History"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: "30px",
                    "&.Mui-selected": {
                      borderRadius: "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      overTimeScreen === "History"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      overTimeScreen === "History"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => setSelectComponent("History")}
              >
                History
              </Mui.ToggleButton>
              {checkFirstLevelApproverPermission(
                userScreenAccess?.module_details,
                "Approve",
                "Advance Salary"
              ) ? (
                <Mui.ToggleButton
                  value="Apply"
                  sx={{
                    flex: 1,
                    textTransform: "capitalize",
                    fontSize: 18,
                    borderRadius: "30px",
                    fontWeight: 600,
                    border: "none",
                    color:
                      overTimeScreen === "Apply"
                        ? themes.whiteColor
                        : themes.headLine,
                    backgroundColor:
                      overTimeScreen === "Apply"
                        ? themes.headLine
                        : themes.lightBrown,
                    "&.Mui-selected": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                      "&:hover": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                      },
                      borderRadius: "30px",
                      "&.Mui-selected": {
                        borderRadius: "30px",
                      },
                    },
                    "&:hover": {
                      backgroundColor:
                        overTimeScreen === "Apply"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        overTimeScreen === "Apply"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                    "&:focus": {
                      backgroundColor:
                        overTimeScreen === "Apply"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        overTimeScreen === "Apply"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                  }}
                  onClick={() => setSelectComponent("Apply")}
                >
                  Apply
                </Mui.ToggleButton>
              ) : null}
            </Mui.ToggleButtonGroup>
          </Mui.Box>
        </Mui.Grid>
        {selectComponent === "Approve" ? (
          <>
            <Mui.Grid xs={4.6}></Mui.Grid>
            <Mui.Grid item xs={2.3} sx={{ padding: 1 }}>
              <CustomAutoComplete
                dataList={departmentData?.map((obj) => ({
                  ...obj,
                  label: obj.department_name,
                }))}
                selectedValue={departmentName}
                updateDataFunction={updateDepartmentName}
                placeHolder="Select department name"
                label="Select Department Name"
              />
            </Mui.Grid>
          </>
        ) : selectComponent === "History" ? (
          <>
            <Mui.Grid item xs={2.2} sx={{ padding: 1 }}>
              <CustomAutoComplete
                dataList={departmentData?.map((obj) => ({
                  ...obj,
                  label: obj.department_name,
                }))}
                selectedValue={departmentName}
                updateDataFunction={updateDepartmentName}
                placeHolder="Select department name"
                label="Select Department Name"
              />
            </Mui.Grid>
            <Mui.Grid item xs={2.2} sx={{ padding: 1 }}>
              <CustomAutoCompleteWithLogo
                dataList={membersData?.map((obj) => ({
                  ...obj,
                  label: obj?.user_name,
                  image: obj?.image_url,
                }))}
                selectedValue={userName}
                updateDataFunction={updateUserName}
                placeHolder="Select employee name"
                label="Select User Name"
                showAvathar={showAutoCompleteAvathar}
                setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
              />
            </Mui.Grid>
            <Mui.Grid item xs={2.5} sx={{ padding: 1 }}>
              <DefaultMonthDateRangePicker
                handleStartDate={handleStartDate}
                showToday={true}
                triggerDate={true}
              />
            </Mui.Grid>
          </>
        ) : null}
      </Mui.Grid>
      {renderComponent()}
    </React.Fragment>
  );
};
